import { render, staticRenderFns } from "./TableListReportCustomer.vue?vue&type=template&id=31696895&scoped=true"
import script from "./TableListReportCustomer.vue?vue&type=script&lang=js"
export * from "./TableListReportCustomer.vue?vue&type=script&lang=js"
import style0 from "./TableListReportCustomer.vue?vue&type=style&index=0&id=31696895&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31696895",
  null
  
)

export default component.exports